import { render } from "./UserProjectsPage.vue?vue&type=template&id=4ae60f5b&ts=true"
import script from "./UserProjectsPage.vue?vue&type=script&lang=ts"
export * from "./UserProjectsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__